/**
 * True when value is null, undefined, or exactly empty string (no trim).
 * Aligns with `Eyeball\Utils\StringUtils::isEmptyOrNull` for API/filter checks.
 */
export function isEmptyOrNull(value: unknown): boolean {
	return value === null || value === undefined || value === "";
}

/**
 * True when value is non-empty and every character is a decimal digit.
 * Aligns with `ctype_digit()` for discover club/team id search.
 */
export function isDigitsOnly(value: string): boolean {
	return value !== "" && /^\d+$/.test(value);
}

/**
 * Left-pad a numeric value as a string (default: two digits with leading zeros).
 */
export function padNumeric(value: number, length = 2, padChar = "0"): string {
	return String(value).padStart(length, padChar);
}
